import BulkEditIcon from '@mui/icons-material/Edit';
import WithEtsyAccount from '../../../pages/etsy/WithEtsyAccount';
import {FeatureObject} from '../../../types/FeatureObject';
import {FeatureStatus} from '../../../types/FeatureStatus';
import {HelpTutorialEnum} from '../../../variables/helpTutorial';
import EtsyBulkCreateGdriveFile from './EtsyBulkCreateGdriveFile';

export const etsyBulkCreateGdriveFile: FeatureObject = {
  type: 'feature',
  title: 'Bulk Create with Gdrive File',
  description:
    'Paste a Google Drive folder shared link and pick the files you need from the folder. Each selected file is uploaded as an Etsy listing, with a matching digital product file attached.',
  IconComponent: BulkEditIcon,
  showFeatureFrontPage: true,
  path: '/etsyBulkCreateGdriveFile',
  component: (user) => (
    <WithEtsyAccount
      featureName="Bulk Create Listings with Gdrive File"
      helpTutorialEnum={HelpTutorialEnum.ETSY_BULK_CREATE_LISTINGS_WITH_GDRIVE_FILE}
      component={(selectedAccount) =>
        selectedAccount ? <EtsyBulkCreateGdriveFile selectedAccount={selectedAccount} user={user} /> : null
      }
    />
  ),
  status: FeatureStatus.PROD,
  tags: ['etsy', 'bulk', 'upload', 'google drive'],
};
